import React from 'react';
import { nanoid } from 'nanoid';
import { WidgetComponent } from '../../Widget';
import './shorts.m.css';

export const ShortsAdWidget = ({ widgetCode, targetingId, mobilePlaceholderHeight, desktopPlaceholderHeight, enableDarkMode }) => {
  let widget = '';
  try {
    if (typeof window !== 'undefined') {
      widget = window.atob(widgetCode);
    } else {
      const buf = Buffer.from(widgetCode, 'base64');
      widget = buf.toString('utf-8');
    }
  } catch (e) {
    widget = '';
  }

  const id = `shorts-ad-${targetingId || 'widget'}`;
  const newId = `${id}-${nanoid()}`;
  let decoded = widget;
  try {
    decoded = decodeURIComponent(widget);
  } catch (e) {
    console.warn('Failed to decode widget URI component, falling back to raw widget string', e);
  }
  const updatedWidgetCode = decoded.replace(/\[unique-id]/g, newId);

  return (
    <div
      data-test-id="shorts-ad-widget"
      styleName="shorts-ad-widget-wrapper"
      style={{
        '--widget-height-mobile': `${mobilePlaceholderHeight || 50}px`,
        '--widget-height-desktop': `${desktopPlaceholderHeight || 50}px`
      }}
    >
      <WidgetComponent widgetValue={updatedWidgetCode} />
    </div>
  );
};
